<template>
  <!-- this component only opens from editPlaylist.vue -->
  <div class="scroll-wrapper">
    <!-- scroll-header -->
    <div class="scroll-header pl-2 is-flex is-flex-direction-column is-align-items-center">
      <b-tooltip
        :triggers="['focus']"
        :delay="2800"
        type="is-black"
        label="Hit enter to search"
        position="is-bottom"
        class="width-100"
      >
        <b-input
          v-model="searchQuery"
          placeholder="Search..."
          type="search"
          icon="magnify"
          class="my-1 width-100"
          rounded
          lazy
        />
      </b-tooltip>

      <!-- filter by muscle groups -->
      <div class="is-flex is-flex-direction-row">
        <b-field>
          <b-radio-button v-model="selectedMuscleGroup"
            :native-value="null"
            type="is-info">
            <strong>All</strong>
          </b-radio-button>
        </b-field>
        <div v-for="(label, value) in muscleGroups" :key="value">
          <b-field>
            <b-radio-button v-model="selectedMuscleGroup"
              :native-value="value"
              type="is-info">
              <strong>{{ label }}</strong>
            </b-radio-button>
          </b-field>
        </div>
      </div>

    </div>
    <section class="scroll-content pb-4">
      <div class="gridContainer">
        <!-- video v-for -->
        <div v-for="(video, videoIdx) in searchResults" :key="videoIdx" class="videoBox">
          <div class="is-flex is-flex-direction-column is-align-items-center">
            <div class="clippingBG">
              <img :src="video.screenshots[1].link" class="clipImage" />
              <div @click="$emit('selectVideo', video)" class="is-overlay is-clickable">
                <div class="iconContainer">
                  <b-icon icon="play-circle-outline" type="is-white" size="is-large" />
                </div>
                <div class="is-overlay timeContainer">
                  <p class="has-text-white">{{ $root.convertTime(video.duration) }}</p>
                </div>
              </div>
            </div>

            <!-- muscle group tags -->
            <div v-if="video.muscle_group_tags" 
              class="is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-center mt-2 mb-0 pb-0">
              <b-field v-for="group in video.muscle_group_tags" :key="group" class="p-0 mb-0">
                <b-tag rounded>{{ muscleGroups[group] }}</b-tag>
              </b-field>
            </div>

            <p class="my-2 px-2">{{ video.name }}</p>
          </div>
          <div class="width-100">
            <b-button
              @click="$emit('addVideo', video)"
              class="is-info is-light mb-1"
              icon-right="plus-thick">
              <strong>Add</strong>
            </b-button>
          </div>


        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  name: "addToPlaylist",
  data() {
    return {
      showSearchTip: false,
      searchQuery: "",
      selectedMuscleGroup: null,
      muscleGroups: {
        'lumbar': 'Lumbar',
        'shoulder': 'Shoulder',
        'hip': 'Hip',
        'knee': 'Knee',
        'handAndWrist': 'Hand & Wrist',
        'footAndAnkle': 'Foot & Ankle',
      },
    };
  },
  methods: {
    searchInput() {
      /*  for performance reasons, I enabled lazy input for the search bar.
          the value of searchQuery only changes on enter, so whenever it changes we want to instead show results by search, not tag
          plus search results are only changed after hitting enter */
      this.selectedMuscleGroup = null;
    }
  },
  computed: {
    searchResults() {
      if (this.selectedMuscleGroup && !this.searchQuery) {
        // filter by muscle groups
        return this.contentVideos.filter(option => {
          // only show tagged items
          if (option.muscle_group_tags) {
            return option.muscle_group_tags.includes(this.selectedMuscleGroup)
          }
        });
      } else {
        // no filter, search by video name
        return this.contentVideos.filter(option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(this.searchQuery.toLowerCase()) >= 0
          );
        });
      }
    },
    ...mapState({
      contentVideos: state => state.contentVideos,
      user: state => state.auth.user
    })
  }
};
</script>


<style lang="scss" scoped>
// TODO: use bulma's .columns.is-multiline.is-one-third
.gridContainer {
  display: grid;
  grid-template-columns: repeat(3, 200px);
  grid-gap: 0.5rem;
}

.videoBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // padding: 0.5rem;
  width: 200px;
  border-radius: 8px;
  border: solid 1px hsl(0, 0%, 86%);
  background-color: white;
  // background-color: hsl(0, 0%, 96%);
}

.clipImage {
  clip-path: inset(20px 0 20px round 8px 8px 0 0) !important;
  // border-radius: 12px 0 0 12px!important;
}
</style>